import _getAppName from "../functions/helpers/getAppName.js";
import _convertToPlainText from "../functions/quill/convertToPlainText.js";
import _convertToHtml from "../functions/quill/convertToHtml.js";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
import _tcLib from "../lib/timecode.js";
import _Event from "../classes/event.js";
import _eol from "eol";
const eol = _eol;
const Event = _Event;
const tcLib = _tcLib;
const removeInvalidEvents = _removeInvalidEvents;
const convertToHtml = _convertToHtml;
const convertToPlainText = _convertToPlainText;
const getAppName = _getAppName;
export default {
  decode: async function (input, options) {
    let events = [],
      ccEvent,
      subtitleBlocks = input.split("\n\n"),
      tcFlag;
    subtitleBlocks.forEach(block => {
      tcFlag = false;
      block.split("\n").forEach(line => {
        let lineArray = line.split(" ");
        if (/\d\d.\d\d.\d\d.\d\d/g.test(lineArray[0]) && /\d\d.\d\d.\d\d.\d\d/g.test(lineArray[1]) && !tcFlag) {
          tcFlag = true;
          ccEvent = new Event();
          lineArray[0] = lineArray[0].replace(/;/g, ":");
          lineArray[1] = lineArray[1].replace(/;/g, ":");
          ccEvent.start = tcLib.tcToSec(lineArray[0], options.frameRate, options.dropFrame);
          ccEvent.end = tcLib.tcToSec(lineArray[1], options.frameRate, options.dropFrame);
        } else if (tcFlag) {
          ccEvent.text += "\n" + line.trim();
        }
      });
      if (ccEvent && ccEvent.text) {
        ccEvent.text = convertToHtml(ccEvent.text.trim());
        events.push(ccEvent);
        ccEvent = undefined;
      }
    });
    return events;
  },
  encode: function (eventGroup, options) {
    let output = "@ This file written by " + getAppName() + "\n\n<begin subtitles>\n";
    eventGroup.events.forEach(event => {
      output += tcLib.secToTc(event.start, options.frameRate, options.dropFrame).replace(/;/g, ":") + " ";
      output += eol.lf(tcLib.secToTc(event.end, options.frameRate, options.dropFrame).replace(/;/g, ":") + "\n");
      output += eol.lf(convertToPlainText(event.text));
      output += eol.lf("\n\n");
    });
    output += "<end subtitles>";
    return output;
  },
  preProcess: {
    encode: function (eventGroup) {
      return removeInvalidEvents(eventGroup);
    },
    decode: function (input) {
      /* All */
      return eol.lf(input.trim()).replace(/'(\n){3,}'/gim, "\n\n");
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      return eventGroup;
    }
  }
};